import {
  Divider,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import { useVersionList } from './use-version-list.ts';
import { Delete, ToggleOff, ToggleOn } from '@mui/icons-material';
import { ConfirmationModal } from '@components/confirmation-modal.tsx';
import { FC, Fragment } from 'react';
import { Version } from '@helpers/types.ts';

interface IVersionListProps {
  onToggleShowDetailVersion: () => void;
  onChangeVersion: (version: Version | null) => void;
}

export const VersionList: FC<IVersionListProps> = (props) => {
  const {
    station,
    versions,
    forDelete,
    showInactive,
    forDisableEnable,
    loadingVersions,
    onDeleteVersion,
    cancelDeleteVersion,
    confirmDeleteVersion,
    onDisableEnableVersion,
    cancelDisableEnableVersion,
    confirmDisableEnableVersion,
    toggleShowInactive,
  } = useVersionList();
  return (
    <>
      <List
        dense
        sx={{
          overflow: 'auto',
          maxHeight: 512,
        }}
      >
        {loadingVersions && <LinearProgress />}
        <ListItem
          secondaryAction={
            <Tooltip title="Mostrar versiones desactivadas">
              <Switch
                size="small"
                checked={showInactive}
                onClick={toggleShowInactive}
              />
            </Tooltip>
          }
        >
          <ListItemText
            primary={`Versiones disponibles en ${station?.station ?? ''}`}
            primaryTypographyProps={{
              color: 'secondary',
            }}
          />
        </ListItem>
        {versions.map((v, i) => (
          <Fragment key={v._id}>
            <ListItem
              component="div"
              disablePadding
              secondaryAction={
                <Stack spacing={0} direction="row">
                  <IconButton
                    edge="end"
                    size="small"
                    onClick={() => onDisableEnableVersion(v)}
                  >
                    {v.active ? (
                      <ToggleOff color={'error'} />
                    ) : (
                      <ToggleOn color={'primary'} />
                    )}
                  </IconButton>
                  <IconButton
                    edge="end"
                    size="small"
                    onClick={() => onDeleteVersion(v)}
                  >
                    <Delete />
                  </IconButton>
                </Stack>
              }
            >
              <ListItemButton
                onClick={() => {
                  props.onChangeVersion(v);
                  props.onToggleShowDetailVersion();
                }}
              >
                <ListItemText
                  primary={v.version}
                  secondary={!v.active && 'Versión desactivada'}
                />
              </ListItemButton>
            </ListItem>
            {i < versions.length - 1 && <Divider component="li" />}
          </Fragment>
        ))}
      </List>
      {forDelete && (
        <ConfirmationModal
          onCancel={cancelDeleteVersion}
          onSuccess={() => {
            props.onChangeVersion(null);
            confirmDeleteVersion();
          }}
        >
          <Typography>
            ¿Está seguro que desea <strong>eliminar</strong> la versión{' '}
            <strong>{forDelete.version}</strong>?
            <br />
            <br />
            <strong>
              {' '}
              <small>está acción no se puede deshacer por ningún medio</small>
            </strong>
          </Typography>
        </ConfirmationModal>
      )}

      {forDisableEnable && (
        <ConfirmationModal
          onCancel={cancelDisableEnableVersion}
          onSuccess={confirmDisableEnableVersion}
        >
          <Typography>
            ¿Está seguro que desea{' '}
            <strong>
              {forDisableEnable.active ? 'desactivar' : 'activar'}
            </strong>{' '}
            la versión <strong>{forDisableEnable.version}</strong>?
            <br />
            <br />
            {forDisableEnable.active && (
              <strong>
                {' '}
                <small>
                  está acción solo impedirá que en el ruteo sea seleccionado
                  esta versión; Esta acción se puede deshacer.
                </small>
              </strong>
            )}
          </Typography>
        </ConfirmationModal>
      )}
    </>
  );
};
